import { createHashHistory } from 'history';

const history = createHashHistory({
    basename: "", // The base URL of the app (see below)
    hashType: "slash", // The hash type to use (see below)
    forceRefresh: false,
});

export default history;
